import '../payment.scss';

import { useEffect, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';

import PaymentGenerated from '../../../../../assets/images/paymentGenerated.svg';

export function GeneratingPaymentModal({
  show,
  onHide,
  redirect,
}: {
  show: boolean;
  onHide: () => void;
  redirect: () => void;
}) {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  useEffect(() => {
    if (!show) {
      setIsLoading(true);
    }
    setTimeout(() => {
      setIsLoading(false);
    }, 4000);
  }, [show]);
  const loadingBody = () => (
    <>
      <div className="d-flex justify-content-center spinner-container">
        <Spinner animation="border" role="status" className="d-block mx-auto" />
      </div>
      <h5 className="text-center mt-3">
        <strong>Gerando pagamento...</strong>
      </h5>
      <p className="text-center text-muted">
        Aguarde alguns instantes, em breve você poderá pagar seu pedido.
      </p>
    </>
  );
  return (
    <Modal className="modal-rounded" show={show} onHide={onHide} centered>
      <Modal.Header className="border-0 pb-0" closeButton />
      <Modal.Body>
        {isLoading && loadingBody()}
        {!isLoading && (
          <>
            <div className="d-flex justify-content-center">
              <img src={PaymentGenerated} />
            </div>
            <h5 className="text-center">
              <strong>Pagamento gerado com sucesso!</strong>
            </h5>
            <p className="text-center text-muted">
              Você pode prosseguir para o pagamento do seu pedido.
            </p>
            <Modal.Footer className="d-flex justify-content-center">
              <button className="btn btn-success w-100" onClick={redirect}>
                Pagar
              </button>
            </Modal.Footer>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}
